import type { NavigationPillar } from '@/lib/navigation-pillars';

export type ShoppingContext = {
    primaryCategoryPath?: string | null;
    navigationPillar?: NavigationPillar | null;
    recentlyViewedProductId?: string;
};

export type RouteDataWithShoppingContext = {
    shoppingContext?: ShoppingContext;
};

export function resolveShoppingContext(
    matches: ReadonlyArray<{ data?: RouteDataWithShoppingContext }>
): ShoppingContext | null {
    for (let index = matches.length - 1; index >= 0; index -= 1) {
        const shoppingContext = matches[index]?.data?.shoppingContext;
        if (shoppingContext) {
            return shoppingContext;
        }
    }

    return null;
}
